import { useTranslation } from 'react-i18next';
import { Text, tokens } from '@hotjar/hotsauce';
import { upsell } from '@hotjar/webapp/domains/revenue/upsell';
import {
  StyledUpsellIllustration,
  StyledFullWidthOverviewWidget,
  StyledHeaderTextContainer,
  StyledUpsellHeader,
  StyledUpsellCard,
  StyledUpsellTitle,
  StyledUpsellBadge,
} from '../styles';
import { WIDGETS } from '../RecordingsOverview';

import type { Site } from '@hotjar/site';

export const ErrorWidgetUpsell = ({ site }: { site: Site }) => {
  const { t } = useTranslation('common');

  const { widgetKey } = WIDGETS.ERRORS;
  const title = t(`recordings.recordings-overview.widget.${widgetKey}.title`);
  const subtitle = t(`recordings.recordings-overview.widget.${widgetKey}.subtitle`);

  return (
    <StyledFullWidthOverviewWidget
      onClick={() =>
        upsell({ site: site as Site, referrer: 'recordings.recommended_error_widget.empty' })
      }
    >
      <StyledUpsellCard>
        <StyledUpsellHeader>
          <StyledHeaderTextContainer>
            <StyledUpsellTitle as="h2" textType="header5">
              {title}
              <StyledUpsellBadge kind="custom" color={tokens.color.azure} size="s">
                {t('recordings.recordings-overview.error-widget-upsell.scale-plan')}
              </StyledUpsellBadge>
            </StyledUpsellTitle>
            <Text role="note" as="span" textColor="text_light" textType="caption">
              {subtitle}
            </Text>
          </StyledHeaderTextContainer>
        </StyledUpsellHeader>
        <StyledUpsellIllustration
          image={WIDGETS.ERRORS.emptyStateImage as string}
          color={WIDGETS.ERRORS.color}
        />
      </StyledUpsellCard>
    </StyledFullWidthOverviewWidget>
  );
};
